export const features = [
  "Acceso ilimitado a TBM Online",
  "+800 clases de Barre, Pilates, Fuerza, Cardio, Jump y Yoga",
  "Programas y clases para complementar tu entrenamiento",
];

export const featuresOnline = [
  "Acceso total a todos los programas",
  "+800 clases en línea",
  "Clases de fuerza, resistencia, cardio, Barre, Pilates, Jump, Yoga & Stretch",
  "Workout Planner para organizar tus clases por objetivo",
  "Filtros por duración, nivel, grupo muscular, tipo de entrenamiento e impacto",
  "Nuevos estrenos cada semana",
];
